module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4VVLtpO22s4qeKqACGScCo-63883193f42e6adeb0e45eef64aefd59.jpg";